import classNames from "classnames"
import React from "react"
import CustomImg from "../../../cms/components/CustomImg"
import SanityNextBackgroundImg from "../../../cms/components/SanityNextBackgroundImg"
import { LinkField } from "../../../containers/editorialPage/converters/link"
import { TwRichTextField } from "../../../root/punks/core/fields/RichTextField"
import {
  CustomImgField,
  RichText,
} from "../../../root/punks/sanity/richText/types"
import TypographyTitle from "../../molecules/TypographyTitle"
import { CustomContainer } from "../../spacings"
import ConditionalLink from "../../utilities/ConditionalLink"
import JsLink from "../../utilities/JsLink"
import { getPercentageWidth } from "../../utilities/width"
import classes from "./CategoriesHero.module.css"

export type ItemVisibility = "always" | "mobile" | "desktop"

export interface CategoriesHeroStyles {
  itemsPerRow?: number
  itemsPerRowMobile?: number
  backgroundColor: string
  backgroundImage?: any
  backgroundImageMobile?: any
  backgroundParallax?: boolean
  textColor: string
}

export interface CategoriesHeroItem {
  label: RichText
  image: CustomImgField
  link?: LinkField
  colSpan?: number
  visibility?: ItemVisibility
}

export interface CategoriesHeroProps {
  caption: RichText
  title: RichText
  styles: CategoriesHeroStyles
  items: CategoriesHeroItem[]
}

const DEFAULT_ITEMS_PER_ROW = 3
const DEFAULT_ITEMS_PER_ROW_MOBILE = 3

const CategoriesHero = ({
  caption,
  title,
  styles,
  items,
}: CategoriesHeroProps) => {
  return (
    <SanityNextBackgroundImg
      style={{
        ["--bg-color" as any]: styles.backgroundColor,
        ["--text-color" as any]: styles.textColor,
      }}
      backgroundSize="cover"
      backgroundPosition="center"
      className={classes.root}
      asset={styles.backgroundImageMobile ?? styles.backgroundImage}
      responsiveImages={{
        md: styles.backgroundImage,
      }}
      backgroundAttachment={styles.backgroundParallax ? "fixed" : undefined}
    >
      <CustomContainer className="text-center">
        <TwRichTextField
          value={caption}
          variant="body2"
          className={classes.caption}
        />
        <TwRichTextField
          value={title}
          variant="h6"
          className={classes.title}
          fontFamily="Quattrocento"
          weight="normal"
        />
        <div className="flex flex-wrap justify-center mt-8 md:mt-16">
          {items.map((x, i) => (
            <JsLink
              key={i}
              className={classNames(classes.item, {
                "md:hidden": x.visibility === "mobile",
                "hidden md:block": x.visibility === "desktop",
              })}
              link={x.link?.url}
              style={{
                ["--item-w" as any]: getPercentageWidth(
                  (styles.itemsPerRowMobile ?? DEFAULT_ITEMS_PER_ROW_MOBILE) /
                    (x.colSpan ?? 1)
                ),
                ["--item-w-md" as any]: getPercentageWidth(
                  (styles.itemsPerRow ?? DEFAULT_ITEMS_PER_ROW) /
                    (x.colSpan ?? 1)
                ),
              }}
            >
              <CustomImg
                value={x.image}
                className="mb-2"
                style={{
                  maxWidth: "100%",
                }}
              />
              <ConditionalLink link={x.link?.url}>
                <TypographyTitle
                  value={x.label}
                  textClassName={classes.label}
                />
              </ConditionalLink>
            </JsLink>
          ))}
        </div>
      </CustomContainer>
    </SanityNextBackgroundImg>
  )
}

export default CategoriesHero
